:root {
  --g-top-bar-height: 48px;
  --g-mobile-top: 59px;
  --g-mobile-bottom: 94px;
  --g-mobile-preview-max-height: 512px; }

._container_1roku_7 {
  --horizontal-padding: 12px;
  --size: 26px;
  --border-radius: 2px;
  position: absolute;
  top: 0;
  right: 0;
  pointer-events: all;
  display: flex;
  align-items: center;
  z-index: 2;
  background-color: #fdd1ba;
  border-bottom-left-radius: var(--border-radius);
  padding: 0 var(--horizontal-padding);
  height: var(--size); }
  ._container_1roku_7._zoomMode_1roku_22 {
    --horizontal-padding: 6px;
    --size: 16px;
    --border-radius: 0; }
    ._container_1roku_7._zoomMode_1roku_22 .control-text {
      line-height: var(--size); }
  ._container_1roku_7:not(._zoomMode_1roku_22):not(._mobile_1roku_28) {
    cursor: pointer; }
  ._container_1roku_7._selected_1roku_30 {
    background-color: #fe620f; }
  ._container_1roku_7:not(._header_1roku_32) {
    top: calc(-1 * var(--size));
    border-top-left-radius: var(--border-radius);
    border-bottom-left-radius: 0; }
  ._container_1roku_7:not(._selected_1roku_30) .control-text {
    color: #fe620f; }
